import React from 'react';
import Sidebar from './Sidebar';

export default function CampaignRulesPage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white md:px-6 lg:px-10 max-w-7xl">
      <Sidebar />
      <div className="flex-1 p-4 lg:p-8">
        <h1 className="text-3xl md:text-5xl leading-14 font-axi-bold my-5">
          Auhinnaloosi kampaaniareeglid
        </h1>

        <ol className="list-decimal pl-4">
          <li className="text-base leading-6 mx-0 my-2">
            “Rademar ja Inbanki auhinnaloos” on 05.10.2026 kuni 30.11.2026
            toimuv tarbijamäng (edaspidi: kampaania), mida korraldab AS Inbank
            Finance, registrikoodiga 16197915, asukohaga Niine 11, Tallinn 10414
            (edaspidi: korraldaja). Kampaania toimub AS-i Inbank Finance
            (edaspidi Inbank) finantseerimise äriüksuse koostööpartneri Rademar
            OÜ (registrikood 10235879, edaspidi: Rademar) müügikohtades.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kampaania läbiviimise kord on kehtestatud korraldaja poolt
            käesolevates reeglites. Kõik korraldaja otsused kampaania
            läbiviimisel on lõplikud ning kõigile kampaanias osalejatele
            kohustuslikud.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kampaanias osalemiseks tuleb kliendil kampaaniaperioodil kasutada
            Rademari füüsilisest kauplusest või e-poest ostes Inbanki “maksa
            järgmisel kuul”, “maksa 3 osas” või “maksa 6 osas” makselahendusi,
            ostu minimaalses väärtuses 125 €.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kampaania auhind on järgnev:
            <ul className="list-disc pl-6">
              <li>
                Kampaanias osalejate vahel loositakse kampaania lõppedes välja 5
                x 100 € Rademari kinkekaarti.
              </li>
            </ul>
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Auhind loositakse välja hiljemalt viie tööpäeva jooksul alates
            kampaania lõpukuupäevast AS Inbank Finance kontoris. Võitja loosib
            juhuslikkuse alusel välja AS-i Inbank Finance turundusjuht või
            turunduse spetsialist.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Võitjaga võetakse auhinna üleandmiseks ühendust e-posti või telefoni
            teel.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kampaania korraldaja kinnitab, et töötleb kampaanias osalejate
            isikuandmeid vastavalt korraldaja privaatsuspoliitikale, järgides
            kõiki isikuandmete kaitse põhimõtteid ning üksnes ulatuses, mis on
            vajalik kampaania läbiviimiseks.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Osalejal on õigus nõuda esitatud isikuandmete parandamist,
            töötlemise piiramist või kustutamist, loobudes sellega kampaanias
            osalemisest. Samuti on osalejal õigus esitada oma isikuandmete
            töötlemisega seotud küsimusi või kaebusi pöördudes kas korraldaja{' '}
            <a className="underline text-rgreen" href="mailto:info@inbank.ee">
              info@inbank.ee
            </a>{' '}
            või Andmekaitse Inspektsiooni poole.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kampaania käigus võidetud auhinda ei asendata võitja soovil teist
            liiki auhinnaga ega hüvitata muul viisil rahas, välja arvatud juhul,
            kui auhind asendatakse teise samaväärse auhinnaga korraldaja
            otsusel.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Vääramatu jõu (<em>force majeure</em>) asjaolude ilmnemisel on
            korraldajal ühepoolne õigus katkestada kampaania ja jätta auhind
            välja loosimata ja/või auhind võitjale üle andmata või asendada
            auhind teist liiki samaväärsete auhinnaga, teatades sellest koheselt
            kampaanias osalejatele korraldaja kodulehe või Facebooki vahendusel.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kõik kampaaniaga seotud vaidlused lahendatakse vastavalt Eesti
            Vabariigis kehtivale seadusandlusele.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Kõik pretensioonid seoses kampaania korraldamise ja/või
            läbiviimisega tuleb saata kirjalikult märksõnaga „Rademar ja Inbanki
            kampaania” hiljemalt 31. detsembriks 2026 aastal korraldaja
            aadressile Niine 11, Tallinn 10414 või meiliaadressile{' '}
            <a className="underline text-rgreen" href="mailto:info@inbank.ee">
              info@inbank.ee
            </a>
            .
          </li>
        </ol>
      </div>
    </div>
  );
}
